// Main course Images
import MilkSoapImg from "./img/Menu/Starter/Aioli-proportioned_170.jpg";
import NeemOilImg from "./img/Menu/Starter/Buffalo Wings_ proportioned_170.jpg";
import ChickenNuggets from "./img/Menu/Starter/Chicken Nuggets - proportioned_170.jpg";
import BeefSteak from "./img/Menu/Starter/Fries_proportioned_170.jpg";
import SweetPotato from "./img/Menu/Starter/Sweet Potato Fries_ proportioned_170.jpg";

// Brekafast Images

import oatsMilk from "./img/Menu/Day Menu/Big Breakfast - proportioned_170.jpg";
import PoachedEggs from "./img/Menu/Day Menu/Bircher_ proportioned_170.jpg";
import Shakshouka from "./img/Menu/Day Menu/Brew Eggs Benny -proportioned_170.jpg";
import smokedSalmon from "./img/Menu/Day Menu/Classic Brekky Burger- proportioned_170.jpg";
import turkeyOmlet from "./img/Menu/Day Menu/Fruit Toast_ proportioned_170.jpg";
import SalmonBagel from "./img/Menu/Day Menu/Salmon Bagel _proportioned_170.jpg";
import SmashedAvocado from "./img/Menu/Day Menu/Smashed Avocado -proportioned_170.jpg";


// Appetizer
import ChickenSpringRolls from "./img/Menu/Lunch & Dinner/Brew Burger - proportioned_170.jpg";
import Edamame from "./img/Menu/Lunch & Dinner/Fried Chicken Burger - proportioned_170.jpg";
import Hummus from "./img/Menu/Lunch & Dinner/Halloumi Bagel - proportioned_170.jpg";
import Sweetpotato_ from "./img/Menu/Lunch & Dinner/Mexi Salad Bowl - proportioned_170.jpg";
import Panzanella from "./img/Menu/Lunch & Dinner/Panzanella Salad - proportioned_170.jpg";
import PulledJackfruit from "./img/Menu/Lunch & Dinner/Pulled Jackfruit Burger - proportioned_170.jpg";
import TacoTrico from "./img/Menu/Lunch & Dinner/Taco Trio - proportioned_170.jpg";

//Burger
import CherryRipe from "./img/Menu/Dessert/Cherry Ripe Dessert - proportioned_170.jpg";
import ChickenBurger from "./img/Menu/Dessert/Churros - proportioned_170.jpg";
import Tuna from "./img/Menu/Dessert/Icecream & Berries - proportioned_170.jpg";
import Nuetella from './img/Menu/Dessert/Nutella Donut -proportioned_170.jpg'
// Grocery Images

// Cereals Images

//Smoothie
import aperolSpritz from "./img/Menu/Alcoholic Beverage/Cocktail/aperol spritz - proportioned_170.jpg";
import EspressoMartini from "./img/Menu/Alcoholic Beverage/Cocktail/Espresso Martini - proportioned_170.jpg";
import margarita from "./img/Menu/Alcoholic Beverage/Cocktail/margarita - proportioned_170.jpg";
import Mimosa from "./img/Menu/Alcoholic Beverage/Cocktail/Mimosa Cocktail - proportioned_170.jpg";

// Honey and Jaggery Images

import Panhead from "./img/Menu/Alcoholic Beverage/Tap Beer/Panhead XPA - proportioned_170.jpg";
import StoneWood from "./img/Menu/Alcoholic Beverage/Tap Beer/Stone _ Wood Pacific Ale - proportioned_170.jpg";
import Stowford from "./img/Menu/Alcoholic Beverage/Tap Beer/stowford press apple cider - proportioned_170.jpg";


//
import Protein from "./img/Menu/Dessert/Nutella Donut -proportioned_170.jpg";
import Diet from "./img/Menu/Dessert/Cherry Ripe Dessert - proportioned_170.jpg";
import Grill from "./img/Menu/Dessert/Cherry Ripe Dessert - proportioned_170.jpg";

// Oils Images

import Greek from "./img/Menu/Starter/Buffalo Wings_ proportioned_170.jpg";
import Rocca from "./img/Menu/Starter/Chicken Nuggets - proportioned_170.jpg";
import Waldrof from "./img/Menu/Starter/Fries_proportioned_170.jpg";

import bullant from "./img/Menu/Alcoholic Beverage/Wine/bullant merlot -proportioned_170.jpg";
import CasaBiancaProsecco from "./img/Menu/Alcoholic Beverage/Wine/Casa Bianca Prosecco - proportioned_170.jpg";
import highgatechardonnay from "./img/Menu//Alcoholic Beverage/Wine/highgate chardonnay - proportioned_170.jpg";

// Pulses Images


// Soup Images
import BeetrootVelvet from "./img/Menu/Other Beverage/Coffee/Beetroot Velvet Latte - proportioned_170.jpg";
import Cappucino from "./img/Menu/Other Beverage/Coffee/Cappucino - proportioned_170.jpg";
import EspressoPiccolo from "./img/Menu/Other Beverage/Coffee/Espresso Piccolo - proportioned_170.jpg";
import FlatWhite from "./img/Menu/Other Beverage/Coffee/Flat White - proportioned_170.jpg";
import HotChocolate2 from "./img/Menu/Other Beverage/Coffee/Hot Chocolate - proportioned_170.jpg";
import MatchaDouble from "./img/Menu/Other Beverage/Coffee/Matcha Double Espresso - proportioned_170.jpg";

//Smoothie

import Banana from './img/Menu/Other Beverage/Smoothie/Banana Milkshake - proportioned_170.png'
import BlueBerry from './img/Menu/Other Beverage/Smoothie/Blueberry Smoothie -  proportioned_170.jpg'
import ChocolateMilkshake from './img/Menu/Other Beverage/Smoothie/Chocolate Milkshake - proportioned_170.jpg'
import StrawberryMilkshake from './img/Menu/Other Beverage/Smoothie/Strawberry Milkshake -  proportioned_170.jpg'

// Tea
import BrookvaleIcedTea from './img/Menu/Other Beverage/Tea/Brookvale Iced Tea - proportioned_170.jpg'
import EnglishBreakfastTea from './img/Menu/Other Beverage/Tea/English Breakfast Tea - proportioned_170.jpg'
import LondonFog from './img/Menu/Other Beverage/Tea/London Fog - proportioned_170.jpg'

//Tropical

import CokeZero from './img/Menu/Other Beverage/Tropical/Coke Ginger Ale Lemonade Soda Tonic Zero - proportioned_170.jpg'
import MixedVegJuice from './img/Menu/Other Beverage/Tropical/Mixed Veg Juice - proportioned_170.jpg'
import OrangeJuice from './img/Menu/Other Beverage/Tropical/Orange Juice -  proportioned_170.jpg'
import StrawberryJuice from './img/Menu/Other Beverage/Tropical/Strawberry Juice - proportioned_170.jpg'
import WatermelonJuice from './img/Menu/Other Beverage/Tropical/Watermelon Juice  - proportioned_170.jpg'


let WebsiteText = {
  products: [
    // Starter Category
    {
      name: "Aioli",
      category: "starter",
      cost: 2.8,
      calorie: "",
      details: "Catalan sauce made of garlic, salt, olive oil, and often egg",
      imageUrl1: MilkSoapImg,
    },
    {
      name: "Buffalo Wings",
      category: "starter",
      imageUrl1: NeemOilImg,
      cost: 14.5,
      calorie: "",
      details: "Crispy Baked Buffalo Wings with American cuisine style",
    },
    {
      name: "Chicken Nuggets",
      category: "starter",
      imageUrl1: ChickenNuggets,
      cost: 12.5,
      calorie: "",
      details: "Small pieces of boneless chicken battered and deep fried",
    },
    {
      name: "Fries",
      category: "starter",
      imageUrl1: BeefSteak,
      imageUrl2: BeefSteak,
      cost: 9.5,
      calorie: "",
      details: "Thin strips of deep-fried potato topped with a choice of condiments",
    },
    {
      name: "Sweet Potato Fries",
      category: "starter",
      imageUrl1: SweetPotato,
      cost: 12.5,
      calorie: "",
      details: "Salty-sweet, crunchy, and spicy fries as your wish",
    },

    // day menu Category
    {
      name: "Big Breakfast",
      category: "dayMenu",
      imageUrl1: oatsMilk,
      imageUrl2: oatsMilk,
      cost: 26.5,
      calorie: "",
      details: "Bacon, pork & fennel sausage, eggs on sourdough, hash brown, grilled tomato & house beans",
    },

    {
      name: "Bircher",
      category: "dayMenu",
      imageUrl1: PoachedEggs,
      cost: 17.5,
      calorie: "",
      details: "Oat & chia bircher, house poached fruit, granola, coconut yoghurt, seasonal berries",
    },
    {
      name: "Brew Eggs 'Benny'",
      category: "dayMenu",
      imageUrl1: Shakshouka,
      cost: 18.5,
      calorie: 346,
      details: "Poached eggs, spinach, hollandaise on toasted sourdough chives",
    },
    {
      name: "Classic Brekky Burger",
      category: "dayMenu",
      imageUrl1: smokedSalmon,
      imageUrl2: smokedSalmon,
      cost: 18.5,
      calorie: "",
      details: "Bacon, poached eggs, hash brown, spinach, hollandaise on span bun",
    },
    {
      name: "Fruit Toast",
      category: "dayMenu",
      imageUrl1: turkeyOmlet,
      imageUrl2: turkeyOmlet,
      cost: 9.5,
      calorie: 237,
      details: "Fruit & Hazelnut Toast date & maple butter",
    },
    {
      name: "Smashed Avocado",
      category: "dayMenu",
      imageUrl1: SmashedAvocado,
      imageUrl2: SmashedAvocado,
      cost: 18.5,
      calorie: "",
      details: "Sautedd mushrooms, garlic sage oil, house bagel seasoning, ricotta, poached egg on grain vienna",
    },
    {
      name: "Salmon Bagel",
      category: "dayMenu",
      imageUrl1: SalmonBagel,
      imageUrl2: SalmonBagel,
      cost: 15.5,
      calorie: "",
      details: "Open-faced smoked bagel toasted with cream cheese, capers and onions, makes for a breakfast or brunch offering",
    },

    // alcoholic Category

    // cocktail Category
    {
      name: "Aperol Spritz",
      category: "alcoholic-cocktail",
      imageUrl1: aperolSpritz,
      imageUrl2: aperolSpritz,
      cost: 16.5,
      calorie: "",
      details: "A zesty orange Italian wine-based cocktail with complex herbal scents harmonized with a touch of vanilla",
    },
    {
      name: "Espresso Martini",
      category: "alcoholic-cocktail",
      imageUrl1: EspressoMartini,
      imageUrl2: EspressoMartini,
      cost: 14.5,
      calorie: "",
      details: "Cold, coffee-flavored cocktail made with vodka, espresso coffee, and coffee liqueur",
    },
    {
      name: "Margarita",
      category: "alcoholic-cocktail",
      imageUrl1: margarita,
      imageUrl2: margarita,
      cost: 12.5,
      calorie: "",
      details: "Classic electric blue margarita",
    },
    {
      name: "Mimosa",
      category: "alcoholic-cocktail",
      imageUrl1: Mimosa,
      imageUrl2: Mimosa,
      cost: 13.5,
      calorie: "",
      details: "A cocktail of sparkling wine and chilled citrus juice",
    },

    // Tap beer Category
    {
      name: "Panhead XPA (NZ)",
      category: "alcoholic-beer",
      imageUrl1: Panhead,
      imageUrl2: margarita,
      cost: 10.5,
      calorie: "",
      details: "The palate largely consists of big mango, guava, lychee and pineapple flavours",
    },
    {
      name: "Stowford Apple Press Cider (USK)",
      category: "alcoholic-beer",
      imageUrl1: StoneWood,
      imageUrl2: StoneWood,
      cost: 13.5,
      calorie: "",
      details: "Refreshing medium-dry sparkling cider bursting with the delicious flavour of crisp cider apples",
    },
    {
      name: "Stone & Wood Pacific Ale (NSW)",
      category: "alcoholic-beer",
      imageUrl1: Stowford,
      imageUrl2: Stowford,
      cost: 24.5,
      calorie: "",
      details: "Stone & Wood's flagship beer containing stone cold classic",
    },

    // Alcoholic wine
    {
      name: "Bullant Cab/Merlot (SA)",
      category: "alcoholic-wine",
      imageUrl1: bullant,
      imageUrl2: bullant,
      cost: 4.5,
      calorie: "",
      details: "An amazing lifted bouquet of blackberries with a touch of mocha",
    },
    {
      name: "Casa Bianca Prosecco (ITALY)",
      category: "alcoholic-wine",
      imageUrl1: CasaBiancaProsecco,
      imageUrl2: CasaBiancaProsecco,
      cost: 40.5,
      calorie: "",
      details: "Italian Prosecco wine would be a match made in heaven with vegetarian, appetizer and snacks",
    },
    {
      name: "Highgate Chardonnay (NSW)",
      category: "alcoholic-wine",
      imageUrl1: highgatechardonnay,
      imageUrl2: highgatechardonnay,
      cost: 10.5,
      calorie: "",
      details: "Fresh aromas of white and yellow stone fruit, with some notes of citrus fruit",
    },

    //Dessert
    {
      name: "Cherry Ripe Dessert Shot",
      category: "dessert",
      imageUrl1: CherryRipe,
      cost: 10.5,
      calorie: "",
      details: "Two layered mini-cups comprising a chocolate base with a creamy strawberry filling and topped with coconut shreds",
    },
    {
      name: "Churros",
      category: "dessert",
      imageUrl1: ChickenBurger,
      cost: 12.5,
      calorie: "",
      details: "A warm, crispy Spanish dessert sprinkled with sugar crystals and served with dark chocolate sauce",
    },
    {
      name: "Ice Cream & Fruit",
      category: "dessert",
      imageUrl1: Tuna,
      cost: 12.5,
      calorie: "",
      details: "Scones topped with ice-cream and fresh berries and a generous serving of in-house coffee caramel",
    },
    {
      name: "Nutella Donut",
      category: "dessert",
      imageUrl1: Nuetella,
      cost: 8.5,
      calorie: "",
      details: "A warm doughnut loaded with nutella ganache",
    },

    //Lunch & Dinner
    {
      name: "Brew Burger",
      category: "lunch",
      imageUrl1: ChickenSpringRolls,
      imageUrl2: ChickenSpringRolls,
      cost: 19.5,
      calorie: "",
      details: "Slow cooked beef brisket, bacon, American cheddar, BBQ sauce, pickle shoestring fries & aioli",
    },
    {
      name: "Fried Chicken Burger",
      category: "lunch",
      imageUrl1: Edamame,
      cost: 19.5,
      calorie: "",
      details: "Fried Chicken, bacon, American cheddar, slaw, chipotle mayo shoestring fries & ailoi",
    },
    {
      name: "Haloumi Bagel Meal",
      category: "lunch",
      imageUrl1: Hummus,
      cost: 18.5,
      calorie: "",
      details: "Grilled haloumi, spinach, tomato, relish, chipotle mayo shoestring fries & aioli",
    },
    {
      name: "Mexi Salad Bowl",
      category: "lunch",
      imageUrl1: Sweetpotato_,
      cost: 18.5,
      calorie: "",
      details: "Avocado hummus, slaw, spinach, grilled corn, spiced crunchy chickpeas, quinoa, tomato salsa span chilli lime vinaigrette",
    },
    {
      name: "Panzanella Salad",
      category: "lunch",
      imageUrl1: Panzanella,
      cost: 18.5,
      calorie: "",
      details: "Heirloom tomatoes, cos, sourdough croutons, cucumber, basil, red onion, ricotta span lemon vinaigrette",
    },
    {
      name: "Taco Trio",
      category: "lunch",
      imageUrl1: TacoTrico,
      cost: 22.5,
      calorie: "",
      details: "Trio of soft shell tacos salsa, slaw, mozzarella, sour cream & jalapenos, your choice of mexi spiced jackfruit or chilli beef",
    },
    {
      name: "Pulled Jackfruit Burger",
      category: "lunch",
      imageUrl1: PulledJackfruit,
      cost: 18.5,
      calorie: "",
      details: "Mexi spiced Jackfruit, tomato salsa, slaw, avocado hummus, shoesstring fries & vegan aioli",
    },

    //Other beverage
    {
      name: "Beetroot Velvet Latte",
      category: "soup-coffee",
      imageUrl1: BeetrootVelvet,
      imageUrl2: BeetrootVelvet,
      cost: 4.5,
      mug: 5.5,
      calorie: "175",
      details: "A creamy beetroot latte made with cashew milk and cooked beetroot.",
    },
    {
      name: "Cappuccino",
      category: "soup-coffee",
      imageUrl1: Cappucino,
      imageUrl2: Cappucino,
      cost: 4.5,
      mug: 5.5,
      details: "An espresso-based coffee drink that originated in Italy, and is prepared with steamed milk foam",
    },
    {
      name: "Espresso Piccolo",
      category: "soup-coffee",
      imageUrl1: EspressoPiccolo,
      imageUrl2: EspressoPiccolo,
      cost: 3.8,
      calorie: "",
      details: "The piccolo latte, small milk beverage topped with steamed, stretched milk, allowing it to blend with the coffee",
    },
    {
      name: "Flat White",
      category: "soup-coffee",
      imageUrl1: FlatWhite,
      imageUrl2: FlatWhite,
      cost: 4.5,
      mug: 5.5,
      details: "Espresso-based coffee drink accompanied with steamed milk and microfoam",
    },
    {
      name: "Hot Chocolate",
      category: "soup-coffee",
      imageUrl1: HotChocolate2,
      imageUrl2: HotChocolate2,
      cost: 4.5,
      mug: 5.5,
      details: "Known as hot cocoa consisting of shaved chocolate, or cocoa powder, heated milk or water, and usually a sweetener",
    },
    {
      name: "Matcha Double Espresso",
      category: "soup-coffee",
      imageUrl1: MatchaDouble,
      imageUrl2: MatchaDouble,
      cost: 4.5,
      calorie: "",
      details: "Matcha Espresso Fusion is a beautifully layered drink of matcha green tea and espresso with milk",
    },

    //Smoothie
    {
      name: "Banana Milkshake",
      category: "soup-smoothie",
      imageUrl1: Banana,
      cost: 9.5,
      calorie: "",
      details: "Banana shake is a sweetened drink made by blending ripe bananas, milk, ice cream, flavorings and a sweetener",
    },
    {
      name: "Blueberry Smoothie",
      category: "soup-smoothie",
      imageUrl1: BlueBerry,
      cost: 9.5,
      calorie: "",
      details: "Blend the blueberries, yogurt, milk, sugar, vanilla, and nutmeg in a blender until frothy",
    },
    {
      name: "Chocolate Milkshake",
      category: "soup-smoothie",
      imageUrl1: ChocolateMilkshake,
      cost: 9.5,
      calorie: "",
      details: "The ultimate in retro comfort food, milkshakes with dark chocolate",
    },
    {
      name: "Strawberry Milkshake",
      category: "soup-smoothie",
      imageUrl1: StrawberryMilkshake,
      cost: 9.5,
      calorie: "",
      details: "A large mixer of the strawberries, ice cream, and milk. Blended until smooth",
    },

    //Tea
    {
      name: "Brookvale Iced Tea",
      category: "soup-tea",
      imageUrl1: BrookvaleIcedTea,
      cost: 4.2,
      calorie: "",
      details: "Peach yet punchy, dark but light, straight but saucy, tight but loose",
    },
    {
      name: "English Breakfast Tea",
      category: "soup-tea",
      imageUrl1: EnglishBreakfastTea,
      cost: 4.2,
      calorie: "",
      details: "Black tea blend usually described as full-bodied, robust, rich and blended to go well with milk and sugar",
    },
    {
      name: "London Fog",
      category: "soup-tea",
      imageUrl1: LondonFog,
      cost: 5.8,
      calorie: "",
      details: "Consists of Earl Grey tea, milk, and vanilla syrup, originating in Canada",
    },

    //Tropical
    {
      name: "Coke Zero, Ginger Ale, Lemonade, Soda, Tonic",
      category: "soup-tropical",
      imageUrl1: CokeZero,
      cost: 4.8,
      calorie: "",
      details: "Soft drinks with carbonated water, caramel color, phosphoric acid, aspartame, potassium benzoate and natural flavors",
    },
    {
      name: "Mixed Veg Juice",
      category: "soup-tropical",
      imageUrl1: MixedVegJuice,
      cost: 4.8,
      calorie: "",
      details: "Juice drink which consists of 4 essential vegetable juices - Tomato Juice, Beetroot Juice, Carrot and Basil extract",
    },
    {
      name: "Orange Juice",
      category: "soup-tropical",
      imageUrl1: OrangeJuice,
      cost: 8.5,
      calorie: "",
      details: "Orange juice is a liquid extract of the orange tree fruit, produced by squeezing or reaming oranges",
    },
    {
      name: "Strawberry Juice",
      category: "soup-tropical",
      imageUrl1: StrawberryJuice,
      cost: 9.5,
      calorie: "",
      details: "A refreshing fresh fruit juice that is full of vitamin C",
    },
    {
      name: "Watermelon Juice",
      category: "soup-tropical",
      imageUrl1: WatermelonJuice,
      cost: 9.5,
      calorie: "",
      details: "Watermelon juice is a refreshing summer cooler made just using watermelon, and black salt",
    }
  ],
};

export default WebsiteText;
